import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RtCarHotListApiServiceOptions {
    apiUrl = `api/carhotlist/`;
    odataUrl = `odata/carhotlist`;
    tripUrl = 'odata/tripDetail';
}
